import React, {Component} from 'react';
import ReduxContacts from "../../../../store/actionreducers/trial_vip/contacts";
import {
    TextField,
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Input,
    Icon,
    Button,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";
import ReduxGlobal from "../../../../store/actionreducers/globalView";

const newTrialVipState = {
    id: '',
    visit_address: {address: ''},
    user: {
        id: '',
        name: '',
        nickname: '',
        email: '',
        cell_phone_no: '',
        birthday: '',
        avatar: {url: 'assets/images/avatars/profile.jpg'},
    }
};

class TrialVipDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {trialVip: newTrialVipState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (!this.props.trialVipDialog) return;

        console.log('this.props.trialVip=', this.props.trialVip);

        /**
         * After Dialog Open
         */
        if (!prevProps.trialVipDialog || (!prevProps.trialVipDialog.props.open && this.props.trialVipDialog.props.open)) {

            /**
             * Dialog type: 'edit'
             * Update State
             */
            if (this.props.trialVipDialog.type === 'edit' &&
                this.props.trialVip &&
                !_.isEqual(this.props.trialVip, prevState.trialVip)) {
                this.setState({trialVip: this.props.trialVip});
            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.trialVipDialog.type === 'new') {
                this.setState({trialVip: newTrialVipState});
            }

        }
    }

    handleChange = (event) => {
        let newTrialVip = null;
        if (event.target.name === 'note') {
            newTrialVip = {...this.state.trialVip, note: event.target.value};
        } else {
            newTrialVip = {
                ...this.state.trialVip,
                user: {...this.state.trialVip.user, [event.target.name]: event.target.value}
            };
            newTrialVip.user.name = newTrialVip.user.family_name + newTrialVip.user.given_name;
            if (event.target.name === 'password') newTrialVip.trial_vip_password = newTrialVip.user.password;
        }
        this.setState({trialVip: newTrialVip});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.trialVipDialog});
    };

    canBeSubmitted() {
        return this.state.trialVip.user && this.state.trialVip.user.name.length > 0;
    }

    render() {
        const {classes, openRemoveContactDialog, trialVipDialog, updateContact} = this.props;

        if (!trialVipDialog || trialVipDialog.props.open === false) return <div/>;
        else return (
            <Dialog className={classes.root} {...trialVipDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {trialVipDialog.type === 'new' ? '新的測試會員資料' : '測試會員資料'}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.trialVip.user.avatar.url}/>
                        {trialVipDialog.type === 'edit' && (
                            <Typography variant="title" color="inherit" className="pt-8">
                                {this.state.trialVip.user.name}
                            </Typography>
                        )}
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">account_circle</Icon>
                        </div>
                        <FormControl className={classes.formControl} required fullWidth>
                            <InputLabel htmlFor="family_name">姓</InputLabel>
                            <Input autoFocus id="family_name" name="family_name"
                                   value={this.state.trialVip.user.family_name}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="given_name">名</InputLabel>
                            <Input id="given_name" name="given_name" value={this.state.trialVip.user.given_name}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">star</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="nickname">暱稱</InputLabel>
                            <Input id="nickname" name="nickname" value={this.state.trialVip.user.nickname}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">phone</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="cell_phone_no">手機號碼</InputLabel>
                            <Input id="cell_phone_no" name="cell_phone_no"
                                   value={this.state.trialVip.user.cell_phone_no}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">email</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth disabled>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input id="email" name="email" value={this.state.trialVip.user.email}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">lock</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="password">密碼</InputLabel>
                            <Input id="password" name="password" value={this.state.trialVip.trial_vip_password}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">wc</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="sex">性別</InputLabel>
                            <Input id="sex" name="sex" value={this.state.trialVip.user.sex}
                                   onChange={this.handleChange}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">cake</Icon>
                        </div>
                        <TextField
                            id="birthday"
                            name="birthday"
                            label="生日"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.trialVip.user.birthday}
                            onChange={this.handleChange}
                        />
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">note</Icon>
                        </div>
                        <TextField
                            className={classes.formControl}
                            id="note"
                            name="note"
                            label="備註"
                            type="text"
                            value={this.state.trialVip.note || ''}
                            onChange={this.handleChange}
                            multiline rows={5} fullWidth
                        />
                    </div>


                    <DialogActions className="justify-between pl-16">
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={!this.canBeSubmitted()}
                            onClick={() => {
                                updateContact(this.state.trialVip);
                                this.closeDataDialog();
                            }}
                        >
                            修改
                        </Button>
                        <IconButton
                            onClick={() => {
                                openRemoveContactDialog(this.state.trialVip.id);
                                this.closeDataDialog();
                            }}
                        >
                            <Icon>delete</Icon>
                        </IconButton>
                    </DialogActions>

                </DialogContent>


            </Dialog>
        );
    }
}

const styles = theme => ({
    root: {},
    formControl: {
        marginBottom: 24
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        closeEditContactDialog: ReduxContacts.ActionCreator.closeEditContactDialog,
        closeNewContactDialog: ReduxContacts.ActionCreator.closeNewContactDialog,
        openRemoveContactDialog: ReduxContacts.ActionCreator.openRemoveContactDialog,
        updateContact: ReduxContacts.ActionCreator.updateContact,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, contactsApp, trialVip: {trialVip}}) {

    return {
        trialVipDialog: dataDialogs[constDataDialogs.name.trialVipDialog],
        contactDialog: contactsApp.contacts.contactDialog,
        trialVip
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(TrialVipDialog));



// WEBPACK FOOTER //
// ./src/main/content/sales/trial_vip/TrialVipDialog.js